class MobileLeftMenu {
    constructor(selector) {
        if (!selector) return;
        
        this.body = document.querySelector("body");
        this.html = document.querySelector("html");
        this.menu = document.querySelector(selector);
        this.markIcon = 'fa-solid fa-xmark fa-flip-horizontal';
        this.hamburgerIcon = 'fa-solid fa-bars-staggered fa-flip-horizontal';

        if ( this.menu === null ){
            return;  
        }
        if (this.menu.dataset.menuIcon) {
            this.hamburgerIcon = this.menu.dataset.menuIcon;
        }
        if (this.menu.dataset.closeIcon) {
            this.markIcon = this.menu.dataset.closeIcon;
        }
        // Full-screen slide-in panel variant (cooldestinations): own header with logo + close button, covers the site header
        this.isPanel = this.menu.classList.contains("c-mobile-left-menu--panel");
        this.panelClose = this.menu.querySelector(".c-mobile-menu-panel-close");
        this.panelBack = this.menu.querySelector(".c-mobile-menu-panel-back"); // panel header back button (shown while a submenu is open)
        this.panelTitle = this.menu.querySelector(".c-mobile-menu-panel-title"); // panel header title beside it (the destination, e.g. "Athens")
        this.menuContainer = this.menu.querySelector(".c-mobile-left-menu-container");
        this.presentation = this.menu.querySelector(".c-mobile-left-menu-presentation"); // the panel's scrolling box
        this.menuButton = this.menu.querySelector(".c-icon-button");
        this.init();
    }

    // The Discover nav: top-level cards, their submenus, "See more" links, submenu back buttons. The lists are read
    // again on every call because tmExploreMenuLoader (mega-menu.js) can replace the nav container's markup. Without
    // a scope (init) everything is bound, as before; with one (refreshNav) only the new nodes inside it, so nothing
    // outside the swapped container is ever bound twice.
    bindNav(scope) {
        this.subMenus = this.menu.querySelectorAll(".activity-button-card-submenu");
        this.subMenuBackButtons = this.menu.querySelectorAll(".activity-button-card-submenu-subheader .c-icon-button");
        this.activityButtons = this.menuContainer.querySelectorAll(".c-activity-button-card");
        this.readMoreButtons = this.menu.querySelectorAll(".activity-button-card-submenu-read-more a");
        const inScope = list => scope ? Array.prototype.filter.call(list, element => scope.contains(element)) : list;

        inScope(this.activityButtons).forEach(button => {
            button.addEventListener("click", (e) => {
                let currentSelectedID = button.getAttribute("data-id");
                this.subMenus.forEach(subMenu => {
                    if (subMenu.id === currentSelectedID) {
                        this.showSubMenu(subMenu);
                    }
                });
            });
        });

        inScope(this.readMoreButtons).forEach(button => {
            button.addEventListener("click", (e) => {
                e.preventDefault();
                e.stopPropagation();                
                
                const textButtonSpan = button.querySelector("span");
                const icon = button.querySelector("i");
                const siblings = button.parentElement.parentElement.querySelectorAll(".activity-button-card-submenu-link-container");

                siblings.forEach(sibling => {
                    if (sibling.classList.contains("hidden")) {
                        sibling.classList.remove("hidden");
                        sibling.classList.add("show");
                    } else if (sibling.classList.contains("show")) {
                        sibling.classList.remove("show");
                        sibling.classList.add("hidden");
                    }
                });
                
                // Button text toggle
                if (textButtonSpan.textContent.trim() === "See more") {
                    textButtonSpan.textContent = "See less";
                    icon.classList.remove("fa-chevron-down");
                    icon.classList.add("fa-chevron-up");                    
                } else {
                    textButtonSpan.textContent = "See more";
                    icon.classList.remove("fa-chevron-up");
                    icon.classList.add("fa-chevron-down");                    
                }

            });
        });

        inScope(this.subMenuBackButtons).forEach(button => {
            button.addEventListener("click", () => {
                this.hideAllSubMenus();
            });
        });
    }

    // After tmExploreMenuLoader swapped in the nav markup: bind the new nodes. An open submenu went with the old
    // nodes, so the open-submenu state (panel back button) is reset with them.
    refreshNav() {
        if (!this.menu || !this.menuContainer) return;
        const navContainer = this.menuContainer.querySelector(".c-mobile-left-menu-nav-container");
        if (!navContainer) return;
        this.bindNav(navContainer);
        this.hideAllSubMenus();
    }

    init() {
        this.bindNav();

        if (this.panelBack) {
            this.panelBack.addEventListener("click", (e) => {
                e.stopPropagation();
                this.hideAllSubMenus();
            });
        }

        if (this.panelClose) {
            this.panelClose.addEventListener("click", (e) => {
                e.stopPropagation();
                this.hideMenu();
            });
        }

        this.menuButton.addEventListener("click", (e) => {
            e.stopPropagation();
            // The panel variant (every site with accounts, not only cooldestinations since step 9b, 2026-09-22) opens the
            // panel; the plain variant slide-toggles the theme's classic nav
            if ( this.isPanel ){
                if (this.menuContainer.classList.contains("show")) {
                    this.hideMenu();
                } else {
                    this.showMenu();
                }
            }else{
                if ( $(".menu-nav").is(":visible") ){
                    $(this.menuButton).find("i").attr("class",this.hamburgerIcon);
                }else{
                    $(this.menuButton).find("i").attr("class",this.markIcon);
                }

                $(".menu-nav, .menu-nav .main-menu").slideToggle();
            }
        });

        document.addEventListener("click", (e) => {
            if (!this.menu.contains(e.target) && this.menuContainer.classList.contains("show")) {
                return; // Prevent hiding menu when clicking outside
            }
        });
    }

    showMenu() {
        let mainHeaderHeight = $("#main-header").height();
        if ( $("#wpadminbar").length ){
            mainHeaderHeight += $("#wpadminbar").height();
        }

        if ( $("#s-search-container-mobile-wrapper").is(":visible") ){
            mainHeaderHeight -= $("#s-search-container-mobile-wrapper").height();
        }

        if (!this.isPanel) {
            $(this.menuContainer).css("margin-top", (mainHeaderHeight-1) + "px");
        }
        this.menuContainer.classList.add("show");
        $(this.menuButton).find("i").attr("class",this.markIcon);
        this.body.classList.add("body-no-scroll");
        this.html.classList.add("html-modal-open");
    }

    hideMenu() {
        this.menuContainer.classList.remove("show");
        $(this.menuButton).find("i").attr("class",this.hamburgerIcon);
        this.hideAllSubMenus();
        this.body.classList.remove("body-no-scroll");
        this.html.classList.remove("html-modal-open");
    }

    showSubMenu(subMenu) {
        this.panelBack?.classList.remove('c-hidden');
        if (this.panelTitle) {
            this.panelTitle.textContent = subMenu.dataset.panelTitle || '';
            this.panelTitle.classList.toggle('c-hidden', !subMenu.dataset.panelTitle);
        }
        // The submenu covers the whole nav from its top, so it opens at its first line wherever the panel was scrolled
        // (Peter, 2026-10-08: it slid in half-way down); Back returns the panel to where it was
        if (this.presentation) {
            this.mainScrollTop = this.presentation.scrollTop;
            this.presentation.scrollTop = 0;
        }
        subMenu.scrollTop = 0;
        subMenu.classList.add("subMenuShow");
    }

    hideAllSubMenus() {
        this.panelBack?.classList.add('c-hidden');
        this.panelTitle?.classList.add('c-hidden');
        if (this.presentation && this.mainScrollTop != null) this.presentation.scrollTop = this.mainScrollTop;
        this.mainScrollTop = null;
        this.subMenus.forEach(subMenu => {
            subMenu.classList.remove("subMenuShow");
        });
    }
}

/* Current language flag/code (header globe dropdown + mobile panel). The server always renders English:
   cooldestinations' translation proxy fetches the English URL (a page cache would bake a proxy language into the
   HTML), and every other site is the English page translated in place by GTranslate (languages-list.php: no
   url_structure). So the visitor's language is read client-side, from where each mode keeps it:
   - cooldestinations (url_structure sub_directory): the first path segment of the page (/da/, /pt/, /zh-CN/ …),
     matched against the panel's data-gt-langs (the full GTranslate list, so an older prefix still resolves) or
     the settings' languages — tmPathLanguageCode();
   - in place: the pick GTranslate's library stores (localStorage __GT_TRANSLATE_LANGS, written as a translation
     starts, removed on English). Not the picker row it marks current (a.gt-current-lang): fn.js moves that on the
     click before its library has loaded (a click right after the hover that starts the load throws, nothing is
     translated) and never moves it on its browser-language auto-switch, so the row can show a language the page
     is not in. The store is written a moment after a pick (the library loads first) and by the auto-switch
     without any event, so the flag is re-read for a while after load and after a pick (watch()).
   tmCurrentLanguageCode() returns that code as GTranslate spells it, or 'en'. tmPathLanguageCode() is the path
   segment alone: a request that must carry the page's /xx/ prefix (the Discover menu fragments, mega-menu.js)
   takes it, because only the proxy serves prefixed URLs — an in-place site has no /fr/wp-admin/ (COOL 639). */
window.tmGTranslateSettings = function () {
    return typeof window.gtranslateSettings === 'object' && window.gtranslateSettings ? window.gtranslateSettings : null;
};
window.tmPathLanguageCode = function () {
    var settings = window.tmGTranslateSettings();
    // Only the redirect mode serves /xx/ URLs; translated in place, a first segment that happens to spell a code
    // (/it/, /no/ …) is a page slug. No settings on the page (no popup): the segment decides, as before
    if (settings && settings.url_structure !== 'sub_directory') return 'en';
    var codeEl = document.querySelector('[data-gt-code][data-gt-langs]');
    var langs = codeEl ? codeEl.getAttribute('data-gt-langs').split(',') : ((settings && settings.languages) || []);
    var seg = (window.location.pathname.split('/')[1] || '').toLowerCase();
    for (var i = 0; i < langs.length; i++) {
        if (langs[i].toLowerCase() === seg) return langs[i];
    }
    return 'en';
};
window.tmCurrentLanguageCode = function () {
    var lang = window.tmPathLanguageCode();
    if (lang !== 'en') return lang;
    var settings = window.tmGTranslateSettings();
    if (settings && settings.url_structure !== 'sub_directory') {
        try {
            var stored = JSON.parse(localStorage.getItem('__GT_TRANSLATE_LANGS'));
            if (stored && typeof stored.tgtLang === 'string' && stored.tgtLang) return stored.tgtLang;
        } catch (e) {}
    }
    return 'en';
};
(function tmCurrentLanguage() {
    function apply() {
        var lang = window.tmCurrentLanguageCode();
        var flag = { en: 'en-us', pt: 'pt-br' }[lang] || lang;
        var flagUrl = 'https://cdn.gtranslate.net/flags/svg/' + encodeURIComponent(flag) + '.svg';
        document.querySelectorAll('[data-gt-flag]').forEach(function (img) {
            if (img.getAttribute('src') !== flagUrl) img.setAttribute('src', flagUrl);
            // LiteSpeed lazy-loads the flag (data-src = the English flag the server rendered) and copies data-src over
            // src when the image first shows: the globe dropdown on its first hover, the phone panel when it opens,
            // both after this watch has ended. Point data-src at the flag too, so the copy keeps it (COOL 640)
            if (img.hasAttribute('data-src') && img.getAttribute('data-src') !== flagUrl) img.setAttribute('data-src', flagUrl);
        });
        document.querySelectorAll('[data-gt-code]').forEach(function (el) { if (el.textContent !== lang.toUpperCase()) el.textContent = lang.toUpperCase(); });
    }
    // In place the store changes a moment after a pick or the auto-switch, with no event to listen to (a same-tab
    // localStorage write fires none): re-read every 300 ms for 10 s after load and after a pick. The redirect
    // mode reloads the page under the new prefix, so there the one read at load is enough
    var watchUntil = 0, watching = false;
    function watch() {
        var settings = window.tmGTranslateSettings();
        if (!settings || settings.url_structure === 'sub_directory') return;
        watchUntil = Date.now() + 10000;
        if (watching) return;
        watching = true;
        (function tick() {
            apply();
            if (Date.now() < watchUntil) setTimeout(tick, 300); else watching = false;
        })();
    }
    function start() { apply(); watch(); }
    window.tmCurrentLanguage = apply;
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
    jQuery(document).on('gTranslateLanguageSelected', watch); // an in-place pick (languages-list.php), no reload
})();
